import { bridge } from "./index";

/**
 * 消息发送工具类
 */

// 数据载体
export interface JSMsgData<T> {
  // 导航功能号（如果要跳转的话，跳到哪里）
  nav_code: number;
  // 执行功能所需的权限（预留）
  auth?: number;
  // 内容实体
  data?: T;
}

// 发送消息
function sendMessage<T>(msg: JSMsgData<T>) {
  bridge.notify("Message", JSON.stringify(msg));
}

// 发送带回调的消息
async function sendMessageResult<T>(msg: JSMsgData<T>, timeoutMs?: number) {
  return bridge.call("Message", JSON.stringify(msg), timeoutMs);
}

const BridgeHelper = {
  sendMessage,
  sendMessageResult,
};

export default BridgeHelper;
